// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Olj3","comment":"styles_comment__Xs21-"};